import axios from "axios";
import { cloneDeep } from "lodash";
import * as types from "constants/ActionTypes";
import { WORKORDER_DATE_TIME_FORMAT } from "helpers/timeHelpers";

export const selectTicket = data => (dispatch, getState) => {
  return dispatch({
    type: types.FETCH_TICKETS,
    value: {
      ticketSelected: data
    }
  });
};

export const onTicketTimeChange = (time, type) => (dispatch, getState) => {
  let ticketSelected = cloneDeep(getState().ticketSelected);
  ticketSelected[type] = time ? time.format(WORKORDER_DATE_TIME_FORMAT) : null;

  return dispatch({
    type: types.ON_TICKET_TIME_CHANGE,
    value: {
      ticketSelected
    }
  });
};

export const closeTicketModal = () => ({
  type: types.CLOSE_TICKET_MODAL,
  value: {
    modal: {
      isTicketModalOpen: false
    }
  }
});

export const getTicketSignature = ticketType => (dispatch, getState) => {
  let ticketId = {};
  let signatureData = {};
  if (ticketType === "workorder") {
    ticketId = getState().workOrderSelected.id;
  } else {
    ticketId = getState().ticketSelected.id;
  }
  axios.get(`/rest-api/signature/${ticketType}/${ticketId}`).then(response => {
    return dispatch({
      type: types.GET_TICKET_SIGNATURE,
      value: {
        signature: response
      }
    });
  });
};
